import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root/Root';
import reportWebVitals from './reportWebVitals';

import 'intersection-observer';
import 'normalize.css';
import './reset.local.css';
import './typography.css';

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
